import React, { FC } from 'react';
import { PageContainer, Title, faListCheck } from '@/ui/components';
import { useTranslate } from '@/translations';
import { Card } from 'antd';
import { ChecklistDataGrid } from './components/ChecklistDataGrid';

export const Checklist: FC = () => {
  const { t } = useTranslate();

  return (
    <PageContainer>
      <Title title={t('functionSettings')} icon={faListCheck} />

      <Card>
        <ChecklistDataGrid />
      </Card>
    </PageContainer>
  );
};
